import React, { useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Alert, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import ParticlesAuth from '../AuthenticationInner/ParticlesAuth';
import logoLight from '../../assets/images/logo-light.png';
import { descargarConexionRdp } from '../../helpers/api_helper';
import { useSelector } from 'react-redux';

const DescargarConexionRdp = () => {
    document.title = "Descargar Conexión RDP | SIGA ERP";
    const tenantId = useSelector((state) => state.Context.tenantId);

    const [formData, setFormData] = useState({
        tenantId: tenantId,
        username: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await descargarConexionRdp(formData);


            // Obtener el blob del archivo
            const blob = response;

            // Extraer nombre del archivo del header Content-Disposition
            const contentDisposition = response.headers?.['content-disposition'];
            let filename = 'conexion_siga.bat';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }

            // Crear enlace de descarga
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

        } catch (err) {
            setError(err.message || 'Credenciales inválidas');
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="mt-lg-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Descargar Conexión RDP</h5>
                                            <p className="text-muted">
                                                Ingrese sus credenciales para descargar el archivo de conexión
                                            </p>
                                        </div>

                                        {error && (
                                            <Alert color="danger" className="mt-3">
                                                <i className="ri-error-warning-line me-2"></i>
                                                {error}
                                            </Alert>
                                        )}

                                        <div className="p-2 mt-4">
                                            <form onSubmit={handleSubmit}>

                                                <div className="mb-3">
                                                    <Label htmlFor="username" className="form-label">
                                                        Usuario
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="username"
                                                        name="username"
                                                        placeholder="Ej: siga-rds\usuario"
                                                        value={formData.username}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="password" className="form-label">
                                                        Contraseña
                                                    </Label>
                                                    <Input
                                                        type="password"
                                                        className="form-control"
                                                        id="password"
                                                        name="password"
                                                        placeholder="Ingrese su contraseña"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>

                                                <div className="mt-4">
                                                    <Button
                                                        color="primary"
                                                        className="btn btn-primary w-100"
                                                        type="submit"
                                                        disabled={loading}
                                                    >
                                                        {loading ? (
                                                            <>
                                                                <Spinner size="sm" className="me-2" />
                                                                Generando...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ri-download-line me-2"></i>
                                                                Descargar Conexión
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default DescargarConexionRdp;
